import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import RegistryPage from '../registry/RegistryPage'
import GiftLogPage  from '../gifts/GiftLogPage'
import PageTip from '../../../components/PageTip'
import { useSwipeTabs } from '../../../lib/swipe'

const TABS = [{ id:'registry', label:'Registry' }, { id:'giftlog', label:'Gift Log' }]

export default function RegistryGiftsPage() {
  const location = useLocation()
  const [tab, setTab] = useState(location.state?.tab || 'registry')
  useEffect(() => { if (location.state?.tab) setTab(location.state.tab) }, [location.state])
  const swipe = useSwipeTabs(TABS.map(t => t.id), tab, setTab)

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'1.25rem' }}>
      <div style={{ display:'flex', borderBottom:'1px solid #E5E0D8' }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            padding:'0.75rem 1.25rem', background:'none', border:'none', cursor:'pointer',
            fontFamily:'Nunito Sans, sans-serif', fontSize:'0.85rem',
            fontWeight: tab === t.id ? 700 : 500,
            color: tab === t.id ? '#C4826A' : '#6B6B6B',
            borderBottom: tab === t.id ? '2px solid #C4826A' : '2px solid transparent',
            transition:'all 0.15s', whiteSpace:'nowrap'
          }}>{t.label}</button>
        ))}
      </div>
      <PageTip id="registry" title="Gifts, sorted"
        points={[
          'Add gift wishes, or a cash fund for the honeymoon and more.',
          'Guests reserve them right from your wedding portal.',
          'The Gift Log tracks what arrived and your thank-yous.',
        ]}/>
      <div {...swipe}>
        {tab === 'registry' && <RegistryPage />}
        {tab === 'giftlog' && <GiftLogPage />}
      </div>
    </div>
  )
}
